import React, { useState } from 'react';
import { Question } from '../types';
import { deleteSurveyQuestion, writeRandomNumbersToResults } from '../Firebase/utils';
import { deleteQuestion } from '../store/features/CreateSurveySlice';
import { useAppDispatch, useAppSelector } from '../store/store';
import ScaleForm from './ScaleForm';
import QuestionPreviewContainer from './QuestionPreviewContainer';
import useDeleteSurveyQuestion from '../CustomHooks/useDeleteSureveyQuestion';

interface ScalePreviewDisplayProps {
    question: Question;
    questionText: string;
    questionBody: {
        min: number;
        max: number;
        step: number;
    };
}

const ScalePreviewDisplay: React.FC<ScalePreviewDisplayProps> = ({ question, questionText, questionBody }) => {

    const [value, setValue] = useState(questionBody.min);
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    
    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);

    const handleEditQuestion = () => {
        writeRandomNumbersToResults(survey.id, question);
        setModalOpen(true);
        // try{
        //     updateSurveyQuestion(user, survey, question);
        //     dispatch(updateQuestion(question));
        // }catch(err){
        //     console.error(err);
        // }        
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(parseInt(e.target.value, 10));
    };

    const generateScaleMarks = () => {
        const marks = [];
        for (let i = questionBody.min; i < questionBody.max; i += questionBody.step) {
            marks.push(i);
        }
        marks.push(100);
        return marks;
    };

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
            <div className="flex flex-col gap-4">
                <div className="flex gap-5">
                    <p>Min: {questionBody?.min}</p>
                </div>
                <div className="flex gap-5">
                    <p>Max: {questionBody?.max}</p>
                </div>
                <div className="flex gap-5">
                    <p>Step: {questionBody?.step}</p>
                </div>
            </div>
            <div className="flex flex-col items-center mt-6">
                <input
                    type="range"
                    min={questionBody.min}
                    max={questionBody.max}
                    step={questionBody.step}
                    value={value}
                    onChange={handleChange}
                    className="w-full"
                />
                {/* <div className="flex justify-between w-full mt-2">
                    {generateScaleMarks().map(mark => (
                        <span key={mark} className="text-xs">
                            {mark}
                        </span>
                    ))}
                </div> */}
            </div>
            <ScaleForm openState={modalOpen} onClose={() => setModalOpen(false)} question={question}/>
        </QuestionPreviewContainer>
    );
};

export default ScalePreviewDisplay;